import { Box, Button } from '@mui/material'
import { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { PageText } from '../components/atoms/PageText'
import { TopTitle } from '../components/atoms/TopTitle'
import { useApp } from '../hooks/useApp'
import { callAxios } from '../hooks/useAxios'
import { ChangePasswordForm } from '../components/forms/ChangePasswordForm'
import { ChangePasswordData } from '../types/auth'

export function VerifyPage(): React.ReactElement {

  const { t } = useTranslation()
  const { token, password } = useParams()
  const [state, setState] = useState<'pending' | 'ok' | 'fail' | 'password'>('pending')
  const navigate = useNavigate()

  const app = useApp()
  const onLogin = () => {
    navigate('/')
  }

  const verify = async () => {
    await callAxios({
      method: 'POST',
      url: '/auth/verify',
    }, { token }).then(res => {
      if (res.success) {
        setState('ok')
      } else {
        setState('fail')
        app.addError(res)
      }
    })
  }

  useEffect(() => {
    if (password) {
      setState('password')
    } else {
      verify()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, password])

  const onChangePassword = async (data: ChangePasswordData) => {
    callAxios({
      method: 'PATCH',
      url: '/users/password',
    }, { ...data, token: password, verify: token }).then(async res => {
      if (res.success) {
        setState('pending')
        await verify()
      } else {
        app.addError(res)
      }
    })
  }

  return (
    <>
      <TopTitle title={t('Welcome to Enion')} />
      <PageText sx={{ mt: 2 }}>
        {state === 'pending' && <Trans>Still verifying...</Trans>}
        {state === 'ok' && <Trans>Your registration was successful.</Trans>}
        {state === 'fail' && <Trans>Your registration failed.</Trans>}
        {state === 'password' && <Trans>Welcome. Please set your password.</Trans>}
      </PageText>

        {state === 'password' && <Box>
          <ChangePasswordForm onSubmit={onChangePassword} label={t('Continue')}/>
        </Box>}

        {state !== 'password' &&
          <Button data-cy="button-Verify Page Login" disabled={state !== 'ok'} fullWidth onClick={onLogin} sx={{ mt: 2 }}>
            <Trans>Login</Trans>
          </Button>
        }
    </>
  )
}
